export default __webpack_public_path__ + "static/media/logo-pt.6f6eceb1.png";